import { jsx as _jsx } from "react/jsx-runtime";
import { Platform, requireNativeComponent } from "react-native";
var isAvailable = Platform.OS === "ios" && !Platform.isTV;
var ZoomEnablerNative = isAvailable ? requireNativeComponent("OneZoomEnabler") : null;
function ZoomTransitionEnabler(props) {
  if (!ZoomEnablerNative) return null;
  return /* @__PURE__ */ _jsx(ZoomEnablerNative, {
    ...props,
    collapsable: false,
    style: {
      position: "absolute",
      width: 1,
      height: 1,
      opacity: 0
    }
  });
}
var ZoomSourceNative = isAvailable ? requireNativeComponent("OneZoomSource") : null;
function ZoomTransitionSource(props) {
  if (!ZoomSourceNative) return null;
  return /* @__PURE__ */ _jsx(ZoomSourceNative, {
    ...props,
    collapsable: false,
    style: {
      display: "flex"
    }
  });
}
var ZoomAlignmentNative = isAvailable ? requireNativeComponent("OneZoomAlignment") : null;
function ZoomTransitionAlignmentRectDetector(props) {
  if (!ZoomAlignmentNative) return null;
  return /* @__PURE__ */ _jsx(ZoomAlignmentNative, {
    ...props,
    collapsable: false,
    style: {
      display: "flex"
    }
  });
}
export {
  ZoomTransitionAlignmentRectDetector,
  ZoomTransitionEnabler,
  ZoomTransitionSource
};
//# sourceMappingURL=index.native.js.map
